module.exports = __webpack_public_path__ + "static/media/023.1b3b6774.jpg";